import { render, staticRenderFns } from "./zTextarea.vue?vue&type=template&id=609a835a&scoped=true&"
import script from "./zTextarea.vue?vue&type=script&lang=js&"
export * from "./zTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a835a",
  null
  
)

export default component.exports